<template>
  <footer class="footer">
    <p>版权所有 ©2021 F F <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">豫ICP备19008341号 - 2</a> </p>
  </footer>
</template>

<script>
  export default {
    name: 'vFooter'
  }
</script>

<style>
  .footer {
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #221822;
  }

  .footer p a {
    color: #787978;
  }

  .footer p a:hover {
    color: #07bddd;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue